<template>
  <div>
    <CRow class="mb-3">
      <CCol col="2" @click="isOpenDoc()" >
        <label class="required font-weight-bold mt-2">
          {{ $t('idp.method') }} <span class="text-danger">*</span>
        </label>
        <CIcon class="text-info ml-1" name="cil-book" size="sm" style="cursor: pointer" />
      </CCol>
      <CCol col="10" class="pl-2 pr-3">
<!--       level {{ levels }} +" "+ C {{ cc }} -->
<!--       wqeqwe {{ option.method.filter(item => { return item.control.filter(cLevel => { return (cLevel.cc.includes(cc) && (cLevel.level === parseInt(levels) ))}).length > 0})  }}-->
        <Multiselect
            class="os"
            v-model="select.method"
            :options="filteredMethods"
            label="label"
            track-by="label"
            :multiple="false"
            :search="true"
            :disabled="formDisabled"
        >
        </Multiselect>

      </CCol>
<!--      <CCol class="mt-3" col="2" v-if='this.$store.getters["idp/method"].filter(item => { return item._id === select.method.value}).length > 0'></CCol>-->
      <CCol  col="12" v-if='this.$store.getters["idp/method"].filter(item => { return item._id === select.method.value && Array.isArray(item.description) && item.description.length > 0}).length > 0'>
        <div class="m-3" v-html='this.$store.getters["idp/method"].filter(item => { return item._id === select.method.value}).at(-1).description.filter(title => { return  (title.key === lang) }).at(-1).value'></div>
      </CCol>
      <CCol v-show="isInHouse" col="2" class="mt-2"><label class="required font-weight-bold mt-2">  {{ $t('idp.course')}} <span class="text-danger">*</span></label></CCol>
      <CCol v-show="isInHouse" col="10" class="pl-2 pr-3 mt-2">
        <Multiselect
            class="os"
            v-model="select.course"
            :options="filteredCourses"
            label="label"
            track-by="label"
            :multiple="false"
            :search="true"
            :disabled="formDisabled"
        >
        </Multiselect>
      </CCol>
    </CRow>
    <CRow v-for="objs in objs.developments" :key="objs.id">
      <CCol col="2" ><label class="required font-weight-bold mt-2">  {{ objs.title.filter(item => { return (item.key === lang) })[0].value }} <span class="text-danger">*</span></label>
<!--        <CButton  v-if="objs.style === 0"  class="ml-2 " size="sm" color="success" shape="pill" variant="outline" @click="onSetInfo(objs.value)">-->
<!--          <span class="font-weight-bold "><CIcon name="cil-people" /></span>-->
<!--        </CButton>-->
      </CCol>
      <CCol col="10" class="pl-2 pr-3 mt-2">
        <CRow v-if="objs.style === 0" class="pb-2">
          <CCol col="10">
            <p class="mt-2" v-if="info.code !== null"> {{ getFormattedInfo(objs) }}</p>

            <p class="mt-2" v-if="info.code === null"> {{ objs.value }}</p>
          </CCol>

          <CCol col="2" class="text-right">
            <CButton  class="ml-2 " size="sm" color="success" shape="pill" variant="outline" @click="onSetInfo(objs)">
              <span class="font-weight-bold "><CIcon name="cil-people" /></span>
            </CButton>
          </CCol>
        </CRow>
        <CRow v-if="objs.style === 1">
          <CCol>
            <CInput :disabled="formDisabled" type="text" :horizontal="{ input:'col-12 text-right' }" v-model="objs.value"></CInput>
          </CCol>
        </CRow>
        <CRow v-if="objs.style === 2">
          <CCol>
            <QEditor class="mb-4" :content="objs" jkey="value" :disabled="formDisabled" @change="(html, key) => { objs[key] = html; }"/>
          </CCol>
        </CRow>

        <CRow v-if="objs.style === 3">
          <CCol >
            <CRow>
              <CCol>
                <CInput :disabled="formDisabled" type="date" v-model="objs.startDate" :min="new moment().set('date',1).set('month',0).add('year',-1).format('YYYY-MM-DD')"></CInput>
              </CCol>
              <label class="pt-2">-</label>
              <CCol>
                <CInput :disabled="formDisabled" type="date" v-model="objs.endDate" :min="new moment(objs.startDate).format('YYYY-MM-DD')"></CInput>
              </CCol>
            </CRow>
          </CCol>
        </CRow>
      </CCol>
    </CRow>

    <IDPSuggestions
      class="mt-4"
      v-if="isVerification.state && shouldRenderVerification"
      :control="isVerification"
      :caption="$t('idp.verification')"
      :content="objs.verification"
    />

    <CRow v-if="isLearnedDeveloper.state"  style="margin-left: -35px; margin-right: -35px;">
      <CCol>
        <CListGroupItem color="dark" class="pb-2 pt-2 bg-dark text-white">
          {{ $t('idp.learnedDeveloper').toUpperCase() }}
        </CListGroupItem>
        <CCardBody class="border-light">
          <CRow   v-for="objs in objs.results" :key="objs.id">

            <CCol col="2" ><label class="required font-weight-bold mt-2">  {{ objs.title.filter(item => { return (item.key === lang) })[0].value }} <span class="text-danger">*</span></label></CCol>
            <CCol col="10" class="pl-2 pr-3 ">

              <CRow v-if="objs.style === 1">
                <CCol>
                  <CInput :disabled="isLearnedDeveloper.disabled" type="text" :horizontal="{ input:'col-12 text-right' }" v-model="objs.value"></CInput>
                </CCol>
              </CRow>
              <CRow v-if="objs.style === 2" class="mb-3">
                <CCol>
                  <QEditor v-show="!isLearnedDeveloper.disabled" :content="objs" jkey="value" :disabled="isLearnedDeveloper.disabled" @change="(html, key) => { objs[key] = html; }"/>
                  <div class="ml-2" v-show="isLearnedDeveloper.disabled" v-html="objs.value"></div>
                </CCol>
              </CRow>

              <CRow v-if="objs.style === 3">
                <CCol >
                  <CRow>
                    <CCol>
                      <CInput :disabled="isLearnedDeveloper.disabled" type="date" v-model="objs.startDate" :min="new moment().set('date',1).set('month',0).add('year',-2).format('YYYY-MM-DD')"></CInput>
                    </CCol>
                    <label class="pt-2">-</label>
                    <CCol>
                      <CInput :disabled="isLearnedDeveloper.disabled" type="date" v-model="objs.endDate" :min="new moment(objs.startDate).format('YYYY-MM-DD')"></CInput>
                    </CCol>
                  </CRow>
                </CCol>
              </CRow>
            </CCol>
          </CRow>
        </CCardBody>
      </CCol>
    </CRow>
    <SearchProfile :is-show="isDialog" :is-select-account="true" @update="onDismiss" :object="nodeData" @select-account="changeAssessment"/>

<!--    <IDPSuggestions v-if="isResults.state" :control="isResults" :caption="$t('idp.results')" :content="objs.results" />-->
  </div>
</template>

<script>

import {mapGetters} from 'vuex'
import Multiselect from "vue-multiselect";
import QEditor from "@/projects/components/Util/QEditor.vue";
import IDPSuggestions from "@/projects/views/E-Performances/IndividualDevelopmentPlan/components/IDPSuggestions.vue";
import SearchProfile from "@/projects/components/Dialog/SearchProfile.vue";
import RequiredValidation from "@/projects/mixins/requiredValidation";

export default {
  name: 'IDPFrom',
  components: {SearchProfile, IDPSuggestions, QEditor, Multiselect},
  mixins: [RequiredValidation],
  props: {
    icon: {
      type: String,
      default: 'cil-user'
    },
    caption: {
      type: String,
      default: 'Individual Development Plan'
    },
    cc: {
      type: Number,
      default:0
    },

    levels: {
      type: [Number, Array],
      default: 0
    },
    objs: {
      type: Object,
      default() {
        return null
      }
    },

    disabled: {
      type: Boolean,
      default: false
    },
    option: {
      type: Object,
      required: true, // ถ้าจำเป็นต้องมี
      default() {
        return {
          course: [],
          method: [],
          faculty: []
        }
      }
    },
  },

  data: function () {
    return {
      isDialog: false,
      isSet : false,
      collapseDuration: 0,
      nodeData: {},
      select: {
        course: "6882dfaa05f817807b3fc75d",
        method: "",
        faculty: ""
      },
      info:{
        code: null,
      },

      objFormat:{
        developments : [],
        results : []
      },

      state: false,
      isInHouse: false,

      isVerification : {
        state : false,
        disabled: false,
        button : false,
        step:1
      },
      isLearnedDeveloper : {
        state : false,
        disabled: false,
        button : false,
        step:2
      },
      isResults : {
        state : false,
        disabled: true,
        button : false,
        step:3
      },


    }
  },

  mounted() {

  },

  created() {
    this.isStateView();
    if(this.objs.code ===  "687f17033e6f7266527ba54f"){
      this.isInHouse = true;
    }else{
      this.isInHouse = false;
    }
  },

  beforeDestroy() {
  },


  methods: {
    getProfileIds() {
      const profile = this.$store.getters["personal/profile"] || {};
      return [profile._id, profile.accounts?._id].filter(Boolean);
    },

    isOwnerUser() {
      const ownerIds = [
        this.$store.getters["idp/idp"]?.accounts?._id,
        this.$store.getters["idp/idp"]?.accounts?.accounts?._id
      ].filter(Boolean);

      return ownerIds.some((id) => this.getProfileIds().includes(id));
    },

    isAssessorUser() {
      const assessorIds = [
        this.$store.getters["idp/idp"]?.assessor?.accounts?._id,
        this.$store.getters["idp/idp"]?.assessor?.accounts?.accounts?._id
      ].filter(Boolean);

      return assessorIds.some((id) => this.getProfileIds().includes(id));
    },

    getCurrentStatusId() {
      return this.$store.getters["idp/idp"]?.status?.at?.(-1)?.state?._id || null;
    },

    getPreviousStatusId() {
      return this.$store.getters["idp/idp"]?.status?.at?.(-2)?.state?._id || null;
    },

    // Fixed: Pure display method - NO assignment to prevent infinite loop
    getFormattedInfo(objs) {
      if (this.info.code !== null && this.info.value) {
        const agencyTitle = this.info.value.agencies?.title?.find(item => item.key === this.lang)?.value || '';
        const workTitle = this.info.value.positions?.at(-1)?.work?.title?.find(item => item.key === this.lang)?.value || '';
        return `${this.info.code} : ${this.info.info} : ${agencyTitle} : ${workTitle}`;
      }
      return objs.value;
    },

    onDismiss(){
      this.isDialog = false;
    },
    onSetInfo(value){
      this.isDialog = true;
    },
    changeAssessment(item, index) {
      this.isDialog = false;
      this.info = item;

      // Update objs.value when user selects a person (outside render cycle)
      if (item && item.code && item.value) {
        this.objs.developments.forEach(dev => {
          if (dev.style === 0) {
            const agencyTitle = item.value.agencies?.title?.find(t => t.key === this.lang)?.value || '';
            const workTitle = item.value.positions?.at(-1)?.work?.title?.find(t => t.key === this.lang)?.value || '';
            dev.value = `${item.code} : ${item.info} : ${agencyTitle} : ${workTitle}`;
          }
        });
      }
    },

    isOpenDoc(){
      window.open('https://docs.google.com/spreadsheets/d/18y1sPa6veloCT9v4wsHrunbL-w_vZEP8hIkqMZ0KNsY/edit?gid=2063267933#gid=2063267933', '_blank');
    },

    isStateView(){
      // this.isVerification = false;
      // this.isLearnedDeveloper = false;
      // this.isResults = false;
      var objs = this.$store.getters["idp/idp"].status.at(-1)
      var previousStatusId = this.getPreviousStatusId()

      if (!objs || !objs.state || !objs.state._id) {
        return;
      }

      this.isVerification = {
        state : false,
        disabled: false,
        button : false,
        step:1
      }
      this.isLearnedDeveloper = {
        state : false,
        disabled: false,
        button : false,
        step:2
      }
      this.isResults = {
        state : false,
        disabled: true,
        button : false,
        step:3
      }

      switch (objs.state._id) {
          // switch ("67bfc7e724e13ba338b58e47") {
        case "654851a37ab25be71bbeeed6": // Pending
          break;
        case "654851dbe41b7f46025977f6": // Save
          break;
        case "654851ece41b7f46025977fa": // Send
          if(this.isAssessorUser()){
            this.isVerification = {
              state : true,
              disabled: false,
              button : true,
              step :1
            }
          }
          break;

        case "670f777373effdb76e17954d": // unsend
          if (previousStatusId === "67bc35d9ac0179614e274a67") {
            this.isLearnedDeveloper = {
              state : true,
              disabled: !this.isOwnerUser(),
              button : false,
              step :2
            }
          } else if (previousStatusId === "67bfc7e724e13ba338b58e47") {
            this.isLearnedDeveloper = {
              state : true,
              disabled: !this.isOwnerUser(),
              button : false,
              step :2
            }
          }
          break;

        case "6723709ab9a2030e40d1b884": // Reject
          if(this.isOwnerUser()){
            this.isVerification = {
              state : true,
              disabled: true,
              button : false,
              step :1
            }
          }
          if(this.isAssessorUser()){
            this.isVerification = {
              state : true,
              disabled: true,
              button : false,
              step :1
            }
          }
          break;

        case "67bc20d5ef3c015b73cf6dbc": // Verification
          if(this.isOwnerUser()){
            this.isVerification = {
              state : true,
              disabled: false,
              button : false,
              step :1
            }
          }
          if(this.isAssessorUser()){
            this.isVerification = {
              state : true,
              disabled: false,
              button : true,
              step :1
            }
          }
          break;

        case "67bc35d9ac0179614e274a67": // development
          if(this.isOwnerUser()){
            this.isVerification = {
              state : true,
              disabled: true,
              button : false,
              step :1
            }
            this.isLearnedDeveloper = {
              state : true,
              disabled: false,
              button : false,
              step :2
            }
          }
          if(this.isAssessorUser()){
            this.isVerification = {
              state : true,
              disabled: true,
              button : false,
              step :1
            }
            this.isLearnedDeveloper = {
              state : true,
              disabled: true,
              button : false,
              step :2
            }
          }
          break;

        case "67bfc7e724e13ba338b58e47": // result in development
          this.isVerification = {
            state : true,
            disabled: true,
            button : false,
            step :1
          }
          this.isLearnedDeveloper = {
            state : true,
            disabled: true,
            button : false,
            step :2
          }
          if(this.isOwnerUser()){
            this.isResults = {
              state : true,
              disabled: true,
              button : false,
              step:3
            }
          }

          if(this.isAssessorUser()){
            this.isResults = {
              state : true,
              disabled: false,
              button : true,
              step:3
            }
          }

          break;

        case "67bfc7ed24e13ba338b58e4d": // complete
          this.isVerification = {
            state : true,
            disabled: true,
            button : false,
            step :1
          }
          this.isLearnedDeveloper = {
            state : true,
            disabled: true,
            button : false,
            step:2
          }
          this.isResults = {
            state : true,
            disabled: true,
            button : false,
            step:3
          }
          break;

      }
    }

  },

  computed: {
    ...mapGetters({
      lang: "setting/lang",
      currentIdp: "idp/idp",
      // agency: 'agency/item',
    }),
    normalizedLevels() {
      const lv = this.levels;
      if (Array.isArray(lv)) {
        return lv.map(n => parseInt(n, 10)).filter(n => !isNaN(n));
      }
      const n = parseInt(lv, 10);
      return isNaN(n) ? [] : [n];
    },

    // Computed property for filtered methods with better error handling
    filteredMethods() {
      // Get method data from store directly (original behavior)
      const methodData = this.$store.getters['idp/method'];

      // Safety checks
      if (!Array.isArray(methodData) || methodData.length === 0) {
        return [];
      }

      const levels = this.normalizedLevels;
      const cc = this.cc;
      const currentLang = this.lang; // Track lang dependency

      return methodData
        .filter(item => {
          if (!item) return false;

          // If no control field, include all items (fallback behavior)
          if (!item.control || !Array.isArray(item.control) || item.control.length === 0) {
            return true; // Include items without control for backward compatibility
          }

          return item.control.some(cLevel => {
            if (!cLevel) return false;

            // If no cc field, check only level
            if (!cLevel.cc || !Array.isArray(cLevel.cc)) {
              return levels.includes(parseInt(cLevel.level));
            }

            const hasCC = cLevel.cc.includes(cc);
            const hasLevel = levels.includes(parseInt(cLevel.level));

            return hasCC && hasLevel;
          });
        })
        .map(item => {
          // Get label based on current language
          let label = item.label || 'Untitled';

          // If title array exists, find the one matching current lang
          if (Array.isArray(item.title) && item.title.length > 0) {
            const titleObj = item.title.find(t => t && t.key === currentLang);
            if (titleObj && titleObj.value) {
              label = titleObj.value;
            } else {
              // Fallback to first title if lang not found
              label = item.title[0]?.value || label;
            }
          }

          return {
            label: label,
            value: item.value || item._id || ''
          };
        });
    },

    // Computed property for filtered courses with language support
    filteredCourses() {
      // Get course data from store directly (original behavior)
      const courseData = this.$store.getters['idp/course'];

      // Safety checks
      if (!Array.isArray(courseData) || courseData.length === 0) {
        return [];
      }

      const currentLang = this.lang; // Track lang dependency

      return courseData
        .map(item => {
          // Get label based on current language
          let label = item.label || 'Untitled';

          // If title array exists, find the one matching current lang
          if (Array.isArray(item.title) && item.title.length > 0) {
            const titleObj = item.title.find(t => t && t.key === currentLang);
            if (titleObj && titleObj.value) {
              label = titleObj.value;
            } else {
              // Fallback to first title if lang not found
              label = item.title[0]?.value || label;
            }
          }

          return {
            label: label,
            value: item.value || item._id || ''
          };
        })
        .sort((a, b) => {
            const numA = Number(a.label.split('.')[0]);
            const numB = Number(b.label.split('.')[0]);
            return numA - numB;
          });
    },

    shouldRenderVerification() {
      const status = this.getCurrentStatusId();

      if (status === "654851ece41b7f46025977fa") { // Send
        return this.isAssessorUser();
      }

      const hiddenStatuses = [
        "670f777373effdb76e17954d" // Unsend
      ];

      return !hiddenStatuses.includes(status);
    },

    formDisabled() {
      const status = this.$store.getters["idp/idp"]?.status?.at?.(-1)?.state?._id;
      const profileId = this.$store.getters["personal/profile"]?._id;
      const ownerId = this.$store.getters["idp/idp"]?.accounts?._id;

      if (!status) {
        return this.disabled;
      }

      const isOwner = ownerId === profileId;

      switch (status) {
        case "654851a37ab25be71bbeeed6": // Pending
        case "654851dbe41b7f46025977f6": // Save
        case "670f777373effdb76e17954d": // unsend
        case "6723709ab9a2030e40d1b884": // Reject
          return this.disabled || !isOwner;
        default:
          return true;
      }
    }
  },

  watch: {
    currentIdp: {
      deep: true,
      handler() {
        this.isStateView();
      }
    },
    lang(value) {
      // When language changes, update selected items to show new labels
      if(this.objs.code !== undefined){
        const selectedMethod = this.filteredMethods.find(item => item.value === this.objs.code);
        if (selectedMethod) {
          this.select.method = selectedMethod;
        }
      }

      if(this.objs.course !== undefined){
        const selectedCourse = this.filteredCourses.find(item => item.value === this.objs.course);
        if (selectedCourse) {
          this.select.course = selectedCourse;
        }
      }
    },

    ['option.method']: function (value) {
      if(this.objs.code !== undefined) {
        const selectedMethod = this.filteredMethods.find(item => item.value === this.objs.code);
        if (selectedMethod) {
          this.select.method = selectedMethod;
          this.isSet = true;
        }
      }
    },

    ['select.method']: function (value, oldValue) {
      if(!value || !value.value) {
        return; // Safety check
      }

      const nextMethodId = value.value;
      const prevMethodId = oldValue && oldValue.value ? oldValue.value : this.objs.code;
      const isMethodChanged = prevMethodId !== nextMethodId;

      if(nextMethodId ===  "687f17033e6f7266527ba54f"){
        this.isInHouse = true;
      }else{
        this.isInHouse = false;
      }

      // Only reset dependent fields when the user actually picked a different method.
      if(this.isSet === false && isMethodChanged){
        this.objs.developments = []
        this.objs.results = []
      }
      this.isSet = false;

      this.objs.code = nextMethodId;

      // Find the original item from store using _id or value
      const methodData = this.$store.getters['idp/method'];
      var objs = methodData.filter(item => {
        return (item._id === nextMethodId || item.value === nextMethodId);
      });

      // Safety check: ensure objs[0] exists before accessing properties
      if(objs.length > 0 && objs[0]) {
        if(this.objs.developments.length === 0 && objs[0].developments){
          this.objs.developments = JSON.parse(JSON.stringify(objs[0].developments));
        }

        if(this.objs.results.length === 0 && objs[0].results){
          this.objs.results = JSON.parse(JSON.stringify(objs[0].results));
        }
      }

      if(this.objs.course !== undefined) {
        const selectedCourse = this.filteredCourses.find(item => item.value === this.objs.course);
        if (selectedCourse) {
          this.select.course = selectedCourse;
        }
      }
    },

    ['select.course']: function (value) {
      this.select.course = value;
      this.objs.course = value.value;
    },

  }
}
</script>
<style>
.text-right > input[type="number"] {
  text-align: right;
}

.c-switch-input + .c-switch-slider {
  background-color: inherit;
  border-color: #fc1515;
}

.c-switch-input + .c-switch-slider::after {
  color: #fc1515;
}

.c-switch-input + .c-switch-slider::before {
  background-color: #fc1515;
  border-color: #fc1515;
}

f-up::first-letter {
  text-transform: uppercase;
}
</style>
